// extracted by mini-css-extract-plugin
export default {"networksTabTitle":"networkSwitcher_networksTabTitle__eD65M","networkSwitchSelect":"networkSwitcher_networkSwitchSelect__C1U+q"};